// --------------------------------------------------------------------------------------------------------------------
// The root-reducer
// --------------------------------------------------------------------------------------------------------------------
import { combineReducers } from 'redux';
import { routerStateReducer } from 'redux-router';

//import reducers
import errorsReducer from './errors';
import browserReducer from './browser';
import menuReducer from './menu';
import jobsReducer from './jobs';
import newsReducer from './news';
import casesReducer from './cases';
import profilesReducer from './profiles';
import editorialsReducer from './editorials';
import userReducer from './users';
import timelinesReducer from './timelines';
import categoriesReducer from './categories';
import accountReducer from './account';
import pageReducer from './page';
import juryReducer from './jury';
import adsReducer from './adverts';
import cookieReducer from './cookie'

const rootReducer = combineReducers({
	errors: errorsReducer,
	browser: browserReducer,
	router: routerStateReducer,
	menu: menuReducer,
	jobs: jobsReducer,
	news: newsReducer,
	cases: casesReducer,
	profiles: profilesReducer,
	editorials: editorialsReducer,
	users: userReducer,
	timelines: timelinesReducer,
	categories: categoriesReducer,
	account: accountReducer,
	page: pageReducer,
	jury: juryReducer,
	ads: adsReducer,
	cookie: cookieReducer,
});

export default rootReducer;



/** WEBPACK FOOTER **
 ** ./frontend/reducers/index.js
 **/